import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useAuth } from 'src/contexts/auth'
import { PregnancyDiagnosisController } from 'src/controllers/pregnancy-diagnosis.controller'
import { SaveDiagnosisCompleteInput } from 'src/services/api/pregnancy-diagnosis.service'

const pregnancyDiagnosisController = new PregnancyDiagnosisController()

export function useSaveDiagnosisComplete() {
  const { userFarm: farmId, username } = useAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['saveDiagnosisComplete'],
    mutationFn: (params: SaveDiagnosisCompleteInput) =>
      pregnancyDiagnosisController.saveDiagnosisComplete(farmId!, { ...params, username: username! }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getPregnancyDiagnosis'] })
    },
    onError: () => {
      toast.error('Erro ao salvar diagnóstico completo')
    }
  })
}
